import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
  { path: '/', component: () => import('@/components/login') },
  { path: '/loginCallback', component: () => import('@/components/loginCallback') },
  { path: '/loginCallbackThird', component: () => import('@/components/loginCallbackThird') },
  { path: '/loginCallbackThirdInfo', component: () => import('@/components/loginCallbackThirdInfo') },

  { path: '/home/welcome', component: () => import('@/views/home/welcome') },
  { path: '/home/alipayFreeze/:code', component: () => import('@/views/home/alipayFreeze') },
  { path: '/home/test', component: () => import('@/views/home/test') },
  { path: '/home/lsQR', component: () => import('@/views/home/relationship') },
  { path: '/home/relationship', component: () => import('@/views/home/relationship') },
  { path: '/home/staticPage/:code', component: () => import('@/views/home/staticPage') },

  { path: '/my/index', component: () => import('@/views/my/my') },
  { path: '/my/changeIcon', component: () => import('@/views/my/changeIcon') },
  { path: '/my/changeHeadIcon', component: () => import('@/views/my/changeHeadIcon') },
  { path: '/my/changeUserQrCode', component: () => import('@/views/my/changeUserQrCode') },
  { path: '/my/updafeInfo', component: () => import('@/views/my/updafeInfo') },
  { path: '/my/updateNameBirthday', component: () => import('@/views/my/updateNameBirthday') },
  { path: '/my/myCerificate', component: () => import('@/views/my/myCerificate') },
  { path: '/my/myCerificateFace/:id', component: () => import('@/views/my/myCerificateFace') },
  { path: '/my/basicCardView/:id', component: () => import('@/views/my/basicCardView') },
  { path: '/my/complaint', component: () => import('@/views/my/complaint') },
  { path: '/my/complaintNew', component: () => import('@/views/my/complaintNew') },
  { path: '/my/complaintNewFinish', component: () => import('@/views/my/complaintNewFinish') },
  { path: '/my/relationShipNetWork', component: () => import('@/views/my/relationShipNetWork') },
  { path: '/my/checkCerificate', component: () => import('@/views/my/checkCerificate') },
  { path: '/c/:code', component: () => import('@/views/my/myCerificateCard') },
  { path: '/my/customerList', component: () => import('@/views/my/customerList') },
  { path: '/my/help', component: () => import('@/views/my/help') },
  { path: '/my/userInfo', component: () => import('@/views/my/userInfo') },
  { path: '/my/vip', component: () => import('@/views/my/vip') },
  { path: '/my/aidaAccount', component: () => import('@/views/my/aidaAccount') },
  { path: '/my/paper', component: () => import('@/views/my/myPaper') },

  { path: '/group/group/:key', component: () => import('@/views/group/group') },
  { path: '/group/giftBox/:key', component: () => import('@/views/group/giftBox') },
  { path: '/group/giftBoxShare/:key', component: () => import('@/views/group/giftBoxShare') },
  { path: '/group/groupShareBuy/:id', component: () => import('@/views/group/groupShareBuy') },
  { path: '/group/groupAddress/:key', meta: { keepAlive: true }, component: () => import('@/views/group/groupAddress') },
  { path: '/group/grouPayType/:key', component: () => import('@/views/group/grouPayType') },
  { path: '/group/groupCommodity/:key', component: () => import('@/views/group/groupCommodity') },
  { path: '/group/team/:id', component: () => import('@/views/group/team') },
  { path: '/group/gpc', component: () => import('@/views/group/gpc') },
  { path: '/group/topList/:key', component: () => import('@/views/group/topList') },
  { path: '/group/scoreWelcome', component: () => import('@/views/group/scoreWelcome') },
  { path: '/group/score', component: () => import('@/views/group/score') },

  { path: '/store/index', meta: { keepAlive: true }, component: () => import('@/views/store/store') },
  { path: '/store/addressEdit', component: () => import('@/views/store/addressEdit') },
  { path: '/store/addressList', component: () => import('@/views/store/addressList') },
  { path: '/store/storetype', meta: { keepAlive: true }, component: () => import('@/views/store/storetype') },
  { path: '/store/car', meta: { keepAlive: true }, component: () => import('@/views/store/car') },
  { path: '/store/search', component: () => import('@/views/store/search') },
  { path: '/store/list', meta: { keepAlive: true }, component: () => import('@/views/store/list') },
  { path: '/store/item/:id', meta: { keepAlive: true }, component: () => import('@/views/store/item') },
  { path: '/store/questionList/:id', component: () => import('@/views/store/questionList') },
  { path: '/store/questionAdd/:id', component: () => import('@/views/store/questionAdd') },
  { path: '/store/questionAnswer/:id', component: () => import('@/views/store/questionAnswer') },
  { path: '/store/orderList', component: () => import('@/views/store/orderList') },
  { path: '/store/orderComment/:id', component: () => import('@/views/store/orderComment') },
  { path: '/store/orderCommentList/:id', component: () => import('@/views/store/orderCommentList') },
  { path: '/store/orderReceiving/:id', component: () => import('@/views/store/orderReceiving') },
  { path: '/store/pay/:id', component: () => import('@/views/store/pay') },
  { path: '/store/payFinish/:id', component: () => import('@/views/store/payFinish') },
  { path: '/store/orderTracking/:id', component: () => import('@/views/store/orderTracking') },
  { path: '/store/payWechat/:id', component: () => import('@/views/store/payWechat') },
  { path: '/store/order/:id', component: () => import('@/views/store/order') },
  { path: '/store/orderDistribution/:id', component: () => import('@/views/store/orderDistribution') },
  { path: '/store/orderCreate', component: () => import('@/views/store/orderCreate') },
  { path: '/store/favorite', component: () => import('@/views/store/favorite') },

  { path: '/pro/index', component: () => import('@/views/pro/proIndex') },
  { path: '/pro/coachHome/:id', component: () => import('@/views/pro/coachHome') },
  { path: '/pro/login', component: () => import('@/views/pro/login') },
  { path: '/pro/bankEdit/:id', component: () => import('@/views/pro/money/bankEdit') },
  { path: '/pro/bankList', component: () => import('@/views/pro/money/bankList') },
  { path: '/pro/commission', component: () => import('@/views/pro/money/commissionIndex') },
  { path: '/pro/moneyCash/:id', component: () => import('@/views/pro/money/moneyCash') },
  { path: '/pro/moneyInfo/:id', component: () => import('@/views/pro/money/moneyInfo') },
  { path: '/pro/moneyList', component: () => import('@/views/pro/money/moneyList') },
  { path: '/pro/moneyCashList', component: () => import('@/views/pro/money/moneyCashList') },

  { path: '/pro/trip/Class/:id', component: () => import('@/views/pro/trip/mgrClass') },
  { path: '/pro/trip/classList', meta: { keepAlive: true }, component: () => import('@/views/pro/trip/mgrClassList') },
  { path: '/pro/trip/trip/:id', component: () => import('@/views/pro/trip/mgrTrip') },
  { path: '/pro/trip/tripList', meta: { keepAlive: true }, component: () => import('@/views/pro/trip/mgrTripList') },
  { path: '/pro/trip/diveOrder/:id', component: () => import('@/views/pro/trip/mgrDiveOrder') },
  { path: '/pro/trip/diveStoreStudent', component: () => import('@/views/pro/trip/mgrDiveStoreStudent') },

  { path: '/pro/examList', component: () => import('@/views/pro/exam/examList') },
  { path: '/pro/examAdd', component: () => import('@/views/pro/exam/examAdd') },
  { path: '/pro/examInfo/:id', component: () => import('@/views/pro/exam/examInfo') },

  { path: '/pro/aidaHome', component: () => import('@/views/pro/aida/aidaHome') },
  { path: '/pro/aidaClass/:id', component: () => import('@/views/pro/aida/aidaClass') },
  { path: '/pro/aidaClassList', component: () => import('@/views/pro/aida/aidaClassList') },
  { path: '/pro/aidaStudentList', component: () => import('@/views/pro/aida/aidaStudentList') },
  { path: '/pro/userBirthday', meta: { keepAlive: true }, component: () => import('@/views/pro/userBirthday') },
  { path: '/pro/propagandalist', meta: { keepAlive: true }, component: () => import('@/views/pro/propaganda/list') },
  { path: '/pro/propaganda/:id', component: () => import('@/views/pro/propaganda/propaganda') },

  { path: '/pic/pic/:id', component: () => import('@/views/pic/pic') },
  { path: '/pic/picIndex', component: () => import('@/views/pic/picIndex') },
  { path: '/pic/picInfo/:id', component: () => import('@/views/pic/picInfo') },
  { path: '/pic/picList', component: () => import('@/views/pic/picList') },
  { path: '/pic/picPay/:id', component: () => import('@/views/pic/picPay') },
  { path: '/pic/picShare/:id', component: () => import('@/views/pic/picShare') },
  { path: '/pic/picState/:id', component: () => import('@/views/pic/picState') },
  { path: '/pic/editCustomerInfo/:id', component: () => import('@/views/pic/editCustomerInfo') },
  { path: '/pic/picListUser', component: () => import('@/views/pic/picListUser') },

  { path: '/dive', meta: { keepAlive: true }, component: () => import('@/views/dive/dive') },
  // { path: '/dive/my', meta: { keepAlive: true }, component: () => import('@/views/dive/divemy') },
  { path: '/dive/my', component: () => import('@/views/my/my') },
  { path: '/divegroup', meta: { keepAlive: true }, component: () => import('@/views/divegroup/group') },
  { path: '/divetrip', meta: { keepAlive: true }, component: () => import('@/views/divetrip/tripList') },
  { path: '/dive/topDiver', component: () => import('@/views/dive/topDiver') },

  { path: '/dive/diveCenterList', component: () => import('@/views/dive/diveCenterList') },
  { path: '/dive/diveCenter/:id', component: () => import('@/views/dive/diveCenter') },
  { path: '/dive/biology/:id', component: () => import('@/views/dive/biology') },
  { path: '/dive/divePlace/:id', component: () => import('@/views/dive/divePlace') },
  { path: '/dive/log/:id', component: () => import('@/views/dive/log') },
  { path: '/dive/logEdit/:id', component: () => import('@/views/dive/logEdit') },
  { path: '/dive/logList', meta: { keepAlive: true }, component: () => import('@/views/dive/logList') },

  { path: '/divetrip/bind/:id', component: () => import('@/views/divetrip/bind') },
  { path: '/divetrip/liveaboardexpand/:id', component: () => import('@/views/divetrip/updateLiveAboardExpand') },
  { path: '/divetrip/liveaboardexpandFinish', component: () => import('@/views/divetrip/updateLiveAboardExpandFinish') },
  { path: '/divetrip/eLearn/:id', component: () => import('@/views/divetrip/eLearn') },
  { path: '/divetrip/eVideo/:id', component: () => import('@/views/divetrip/eVideo') },
  { path: '/divetrip/exam', component: () => import('@/views/divetrip/exam') },
  { path: '/divetrip/examErrorList/:id', component: () => import('@/views/divetrip/examErrorList') },
  { path: '/divetrip/examFinish/:id', component: () => import('@/views/divetrip/examFinish') },
  { path: '/divetrip/examPrint/:id', component: () => import('@/views/divetrip/examPrint') },
  { path: '/divetrip/trip/:id', component: () => import('@/views/divetrip/trip') },
  { path: '/divetrip/tripComment/:id', component: () => import('@/views/divetrip/tripComment') },
  { path: '/divetrip/tripCommentView/:id', component: () => import('@/views/divetrip/tripCommentView') },
  { path: '/divetrip/myExam', component: () => import('@/views/divetrip/myExam') },
  { path: '/divetrip/liveaboardcomment/:id', component: () => import('@/views/divetrip/liveaboardcomment') },

  { path: '/insurance/info/:id', component: () => import('@/views/insurance/info') },
  { path: '/insurance/list', meta: { keepAlive: true }, component: () => import('@/views/insurance/list') },
  { path: '/insurance/create/:id', component: () => import('@/views/insurance/create') },
  { path: '/insurance/myInfo/:id', component: () => import('@/views/insurance/myInfo') },
  { path: '/insurance/myList', meta: { keepAlive: true }, component: () => import('@/views/insurance/myList') },

  { path: '/m/:code', component: () => import('@/views/memberCard/memberCardInfo') },
  { path: '/memberCard/memberCardList', component: () => import('@/views/memberCard/memberCardList') },
  { path: '/memberCard/poster/:code', component: () => import('@/views/memberCard/memberCardPoster') },
  { path: '/memberCard/buy/:code', component: () => import('@/views/memberCard/memberCardBuy') },
  { path: '/memberCard/subscribe', component: () => import('@/views/memberCard/memberCardSubscribe') },
  { path: '/memberCard/subscribelist', component: () => import('@/views/memberCard/memberCardSubscribeList') },
  { path: '/memberCard/reserverAdd', component: () => import('@/views/memberCard/memberCardReserverAdd') },

  { path: '/boat', component: () => import('@/views/boat/boatHome') },
  { path: '/boat/boatCountryList',meta: { keepAlive: true }, component: () => import('@/views/boat/boatCountryList') },
  { path: '/boat/boatTourInfo/:code', component: () => import('@/views/boat/boatTourInfo') },
  { path: '/boat/boatFollow', component: () => import('@/views/boat/boatFollow') },

  { path: '/ilab/202010', component: () => import('@/views/third/ilab/testGreen') },
  // { path: '/ilab/202010Ready', component: () => import('@/views/third/ilab/testGreenReady') }
  { path: '/ilab/202104', component: () => import('@/views/third/ilab/travel') },
  { path: '/ilab/2021041', component: () => import('@/views/third/ilab/travel1') },
  { path: '/ilab/202205', component: () => import('@/views/third/ilab/202205') },
  { path: '/ilab/202209', component: () => import('@/views/third/ilab/202209') },
  { path: '/ilab/202209Demo', component: () => import('@/views/third/ilab/202209Demo') },

  { path: '/ilab/worldOceanDay', component: () => import('@/views/third/ilab/worldOceanDay') },
  { path: '/ssioceanday', component: () => import('@/views/third/ssi/oceanday') },
  { path: '/cooldive/20211111', component: () => import('@/views/third/cooldive/depositExpand') },
  { path: '/cooldive/202201', component: () => import('@/views/third/cooldive/getMermaid') },

  { path: '/burning/2024', component: () => import('@/views/third/burning/2024') },

  { path: '/mermaid/agentList', component: () => import('@/views/mermaid/mermaidAgentList') },
  { path: '/mermaid/agent/:id', component: () => import('@/views/mermaid/mermaidAgent') },
  { path: '/mermaid/bind/:id', component: () => import('@/views/mermaid/mermaidBind') },
  { path: '/mermaid/mermaidUser', component: () => import('@/views/mermaid/mermaidUser') }
]
export default new Router({
  routes: routes,
  mode: 'history'
})
